export default "__VITE_ASSET__DFthF6WX__"